import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Nhân sự (Ezy › hr). Mã nghiệp vụ, tên riêng và dữ liệu không dịch.
addMessages('vi', {
  'hr.kr.noData': 'chưa có dữ liệu',
  'hr.kr.period': 'Kỳ',
  'hr.kr.kindLabel': 'Loại định nghĩa',
  'hr.kr.pending': 'chờ anh chốt',
  'hr.kr.metricKind': 'Chỉ số (Kind = Metric)',
  'hr.kr.metricSub': '36 dòng · hiện {n} đã map tên',
  'hr.kr.thCode': 'Mã',
  'hr.kr.thName': 'Tên',
  'hr.kr.thDept': 'Phòng',
  'hr.kr.thUnit': 'Đơn vị',
  'hr.kr.thDir': 'Hướng',
  'hr.kr.thSource': 'Nguồn',
  'hr.kr.thWeight': 'Trọng số · mốc',
  'hr.kr.penKind': 'Danh mục phạt (Kind = Penalty)',
  'hr.kr.penSub': '9 dòng · dùng ở Ghi nhận sai sót',
  'hr.kr.rewKind': 'Danh mục thưởng (Kind = Reward)',
  'hr.kr.rewSub': '5 dòng · 3 đã map tên',
  'hr.kr.rPraise': 'Khách khen bằng văn bản',
  'hr.kr.rRecover': 'Thu hồi được phí phát sinh',
  'hr.kr.rSave': 'Tiết kiệm chi phí',
  'hr.kr.rOther': '2 dòng khác',
  'hr.kr.rUnmapped': 'chưa map tên',
  'hr.kr.sevKind': 'Mức độ (Kind = Severity)',
  'hr.kr.sevSub': '4 dòng',
  'hr.kr.l1': 'Nhắc nhở, không phát sinh phí',
  'hr.kr.l2': 'Thiệt hại nhỏ',
  'hr.kr.l3': 'Thiệt hại vừa',
  'hr.kr.l4': 'Nghiêm trọng / mất khách / pháp lý',
  'hr.kr.sevPenalty': 'Điểm trừ theo mức, hệ số tái phạm',
  'hr.kr.unitKind': 'Điểm theo sản lượng',
  'hr.kr.paramKind': 'Tham số',
  'hr.kr.rows': '{n} dòng',
  'hr.kr.unitNote': 'Điểm thưởng theo từng đơn vị sản lượng (job, chuyến, dịch vụ hoàn thành…).\nSố điểm mỗi đơn vị: chờ anh chốt.',
  'hr.kr.paramNote': 'Ngưỡng hạng, biên điều chỉnh của quản lý, cỡ mẫu tối thiểu, hệ số tái phạm…\nTất cả giá trị: chờ anh chốt. Đổi tham số có hiệu lực từ kỳ sau, kỳ đã chốt không đổi.',
  'hr.kr.metrics': 'Chỉ số',
  'hr.kr.defParam': 'định nghĩa · tham số',
  'hr.kr.unitPts': 'Điểm sản lượng',
  'hr.kr.penRewSev': 'Phạt / Thưởng / Mức',
  'hr.kr.rules': 'Luật tính thưởng',
  'hr.kr.rulesSub': 'theo ghế + bậc',
  'hr.kr.seat': 'Ghế',
  'hr.kr.grade': 'Bậc',
  'hr.kr.field': 'Trường đo',
  'hr.kr.how': 'Cách tính',
  'hr.kr.effFrom': 'Hiệu lực từ',
  'hr.kr.noRules': 'Chưa có luật nào.',
  'hr.noWrite': 'Chưa mở ghi ở bản này',
  'hr.notYet': 'Tab này chưa mở ở bản này',
  'hr.retry': 'Thử lại',
  'hr.backOverview': 'Về Tổng quan',
  'hr.kpi.title': 'KPI',
  'hr.kpi.live': 'Đang mở',
  'hr.kpi.cycle': 'Chu kỳ',
  'hr.kpi.month': 'Tháng',
  'hr.kpi.quarter': 'Quý',
  'hr.kpi.period': 'Kỳ',
  'hr.kpi.prev': 'Kỳ trước',
  'hr.kpi.next': 'Kỳ sau',
  'hr.kpi.sampleOnly': 'Chỉ có dữ liệu mẫu Oct/2026',
  'hr.kpi.density': 'Mật độ',
  'hr.kpi.std': 'Chuẩn',
  'hr.kpi.compact': 'Gọn',
  'hr.kpi.notifTool': 'Thông báo',
  'hr.kpi.notif': '4 thông báo mới · mở ở Việc & Duyệt',
  'hr.kpi.openRight': 'Mở cột phải',
  'hr.kpi.close': 'Chốt kỳ',
  'hr.kpi.addRule': 'Thêm luật',
  'hr.kpi.closeOct': 'Chốt kỳ Oct/2026',
  'hr.kpi.exportMine': 'Xuất thẻ của tôi',
  'hr.kpi.export': 'Xuất KPI',
  'hr.kpi.emptyTitle': 'Chưa có kỳ KPI',
  'hr.kpi.emptyDesc': 'Kỳ này chưa có dữ liệu chỉ số.',
  'hr.kpi.metrics': 'Chỉ số',
  'hr.kpi.scoredStaff': 'Nhân sự tính KPI',
  'hr.kpi.avgCo': 'Điểm TB công ty',
  'hr.kpi.avgNote': 'điểm chất lượng 0–100',
  'hr.kpi.grade': 'Hạng {g}',
  'hr.kpi.avgByDept': 'Điểm trung bình theo phòng',
  'hr.kpi.avgDept': 'Điểm TB phòng',
  'hr.kpi.avgCoShort': 'TB công ty',
  'hr.kpi.scale': 'thang 0–100',
  'hr.kpi.grading': 'Phân hạng',
  'hr.kpi.gradingKpi': 'Phân hạng KPI',
  'hr.kpi.people': '{n} người',
  'hr.kpi.coRate': 'Tỷ lệ đạt cấp công ty',
  'hr.kpi.noTarget': 'chỉ tiêu công ty chưa đặt',
  'hr.kpi.coMetrics': 'Chỉ số cấp công ty',
  'hr.kpi.noTargetSrc': 'chỉ tiêu công ty chưa đặt · số thật lấy từ MINT/db',
  'hr.kpi.setTarget': 'Đặt chỉ tiêu công ty',
  'hr.kpi.thMetric': 'Chỉ số',
  'hr.kpi.thDept': 'Phòng',
  'hr.kpi.thActual': 'Thực tế',
  'hr.kpi.thTarget': 'Chỉ tiêu',
  'hr.kpi.thData': 'Số liệu',
  'hr.kpi.thSource': 'Nguồn',
  'hr.kc.short': 'Thiếu',
  'hr.kc.enough': 'Đủ',
  'hr.kc.timesheet': 'Bảng công tháng',
  'hr.kc.left': 'Còn',
  'hr.kc.done': 'Xong',
  'hr.kc.cases': '{n} vụ',
  'hr.kc.pendingEv': 'Sai sót / khen thưởng chưa duyệt',
  'hr.kc.loaded': 'đã nạp',
  'hr.kc.actionMark': 'Dấu thao tác',
  'hr.kc.wait': 'Chờ',
  'hr.kc.notSet': 'chưa đặt',
  'hr.kc.coTarget': 'Chỉ tiêu công ty',
  'hr.kc.metrics': 'Chỉ số',
  'hr.kc.period': 'Kỳ',
  'hr.kc.openRecalc': 'đang mở · điểm tính lại khi dữ liệu đổi',
  'hr.kc.staffInPeriod': 'Nhân sự trong kỳ',
  'hr.kc.scoredN': '{n} có điểm',
  'hr.kc.sheetsHave': 'Bảng công đã có',
  'hr.kc.openCases': 'Vụ sai sót đang mở',
  'hr.kc.notEffNoCount': 'chưa hiệu lực thì không tính',
  'hr.kc.readiness': 'Mức sẵn sàng chốt',
  'hr.kc.readinessSub': 'bảng công và điểm của kỳ Oct/2026',
  'hr.kc.staffScored': 'Nhân sự có điểm',
  'hr.kc.noMetricSet': 'còn {n} chưa có bộ chỉ số',
  'hr.kc.before': 'Trước khi chốt',
  'hr.kc.noRecalc': 'chốt rồi không tính lại',
  'hr.kc.who': 'Ai được chốt',
  'hr.kc.bySeat': 'theo ghế',
  'hr.kc.closer': 'Chốt kỳ',
  'hr.kc.proxy': 'HRD-MGR chốt thay',
  'hr.kc.proxySub': 'ghế BOD-DIR trống thì leo theo ReportTo',
  'hr.kc.proxyNo': 'Không · chỉ BOD-DIR chốt',
  'hr.kc.writeTo': 'Ghi vào',
  'hr.kc.noData': 'chưa có dữ liệu',
  'hr.kc.periods': 'Các kỳ',
  'hr.kc.noneClosed': 'chưa kỳ nào được chốt',
  'hr.kc.status': 'Trạng thái',
  'hr.kc.closedBy': 'Người chốt',
  'hr.kc.closedOn': 'Ngày chốt',
  'hr.kc.headcount': 'Số người',
  'hr.kc.live': 'Đang mở',
  'hr.kc.notClosed': 'Chưa chốt',
  'hr.ov.title': 'Nhân sự & lương',
  'hr.ov.updated': 'Cập nhật lúc',
  'hr.ov.apprWait': 'Duyệt chờ tôi',
  'hr.ov.tasks': 'Việc',
  'hr.ov.more': 'Thao tác khác',
  'hr.ov.assignSeat': 'Giao ghế',
  'hr.ov.newLeave': 'Tạo đơn nghỉ',
  'hr.ov.group': 'Nhóm nhân sự',
  'hr.ov.emptyT': 'Chưa có đơn nghỉ nào trong kỳ',
  'hr.ov.emptyD': 'Tháng 10/2026 chưa có đơn nghỉ, phiếu làm thêm giờ hay đề nghị tuyển.',
  'hr.ov.tabClosed': 'Tab này chưa mở ở bản này',
  'hr.ov.writeSuffix': '{msg} · chưa mở ghi ở bản này',
  'hr.ov.upcoming': 'Sự kiện sắp tới',
  'hr.ov.upcomingHd': 'Sự kiện sắp tới · 30 ngày',
  'hr.ov.toHandle': '{n} cần xử lý',
  'hr.ov.handled': 'Đã xử lý',
  'hr.ov.moves': 'Biến động nhân sự',
  'hr.ov.movesHd': 'Biến động nhân sự · 2026',
  'hr.ov.lgWorking': 'Đang làm',
  'hr.ov.lgIn': 'Vào',
  'hr.ov.lgOut': 'Nghỉ',
  'hr.ov.chartAria': 'Số người đang làm cuối tháng 2026: {list}. Vào {vin}, nghỉ {vout} người từ đầu năm',
  'hr.ov.barTip': 'T{m}: vào {a} · nghỉ {b}',
  'hr.ov.note': 'Vào {vin} · nghỉ {vout} từ đầu năm',
  'hr.ov.leave': 'Phân tích nghỉ phép',
  'hr.ov.leaveHd': 'Nghỉ phép theo tháng · 2026',
  'hr.ov.leaveSub': 'ngày nghỉ đã duyệt',
  'hr.ov.leaveTip': 'Tháng {m}: {v} ngày nghỉ đã duyệt',
  'hr.ov.topLeave': 'Nghỉ nhiều nhất năm nay',
  'hr.ov.days': '{v} ngày',
  'hr.ov.mix': 'Cơ cấu nhân sự',
  'hr.ov.mixSub': '37 đang làm',
  'hr.ov.mixTip': 'Số gộp, không hiện cá nhân',
  'hr.ov.gender': 'Giới tính',
  'hr.ov.age': 'Độ tuổi',
  'hr.ov.byDept': 'Thống kê theo phòng',
  'hr.ov.thDept': 'Phòng',
  'hr.ov.thFill': 'Thực tế / định biên',
  'hr.ov.thGap': 'Khuyết',
  'hr.ov.thMgr': 'Quản lý',
  'hr.ov.thAge': 'Tuổi TB',
  'hr.ov.thNote': 'Ghi chú',
  'hr.ov.fillAria': '{name}: {act} trên định biên {plan}',
  'hr.tab.ov': 'Tổng quan',
  'hr.tab.staff': 'Nhân sự',
  'hr.tab.org': 'Cơ cấu & ghế',
  'hr.tab.time': 'Chấm công',
  'hr.tab.leave': 'Nghỉ phép & bàn giao',
  'hr.tab.ot': 'Làm thêm giờ',
  'hr.tab.pay': 'Lương',
  'hr.tab.kpi': 'KPI',
  'hr.tab.rec': 'Tuyển dụng',
  'hr.kp.dept': 'Phòng',
  'hr.kp.all': 'Tất cả',
  'hr.kp.base': 'Điểm gốc',
  'hr.kp.baseSub': 'TB điểm các chỉ số',
  'hr.kp.pen': 'Sai sót hiệu lực',
  'hr.kp.penSub': 'trừ điểm · mức chờ anh chốt',
  'hr.kp.rew': 'Khen thưởng hiệu lực',
  'hr.kp.rewSub': 'cộng điểm · mức chờ anh chốt',
  'hr.kp.adj': 'Điều chỉnh quản lý',
  'hr.kp.adjSub': 'chưa điều chỉnh',
  'hr.kp.fin': 'Điểm cuối',
  'hr.kp.grade': 'Hạng {g}',
  'hr.kp.mineLbl': 'KPI của tôi {u}',
  'hr.kp.mineHd': 'KPI của tôi · {u}',
  'hr.kp.confirm': 'xác nhận: {m}',
  'hr.kp.mgrAdj': 'Điều chỉnh của quản lý',
  'hr.kp.byMetric': 'Điểm theo chỉ số',
  'hr.kp.byMetricSub': 'điểm 0–100 · màu theo hạng của điểm',
  'hr.kp.metrics': 'Chỉ số',
  'hr.kp.noSet': 'vị trí này chưa có bộ chỉ số',
  'hr.kp.weights': 'trọng số và mốc điểm: chờ anh chốt',
  'hr.kp.code': 'Mã',
  'hr.kp.actual': 'Thực tế',
  'hr.kp.dir': 'Hướng',
  'hr.kp.score': 'Điểm',
  'hr.kp.data': 'Số liệu',
  'hr.kp.src': 'Nguồn',
  'hr.kp.higher': 'cao tốt',
  'hr.kp.lower': 'thấp tốt',
  'hr.kp.real': 'Thực tế',
  'hr.kp.sample': 'Mẫu',
  'hr.kp.noSeatSet': 'Chưa có bộ chỉ số cho ghế {seat} · chờ anh chốt',
  'hr.kp.evHd': 'Sai sót & khen thưởng',
  'hr.kp.evSub': 'chỉ vụ Hiệu lực mới tính điểm · sổ ở Báo cáo BOD',
  'hr.kp.openLedgerNote': 'Mở Báo cáo BOD › Sai sót & khen thưởng',
  'hr.kp.openLedger': 'Mở sổ ›',
  'hr.kp.pen1': 'Sai sót',
  'hr.kp.rew1': 'Khen thưởng',
  'hr.kp.noEv': 'Không có vụ nào trong kỳ',
  'hr.kp.staff': 'Nhân sự',
  'hr.kp.staffSub': '{n} người · bấm để xem thẻ',
  'hr.kp.person': 'Người',
  'hr.kp.seat': 'Ghế',
  'hr.kp.gradeCol': 'Hạng',
  'hr.kd.pos': 'Vị trí',
  'hr.kd.view': 'Xem',
  'hr.kd.quality': 'Chất lượng',
  'hr.kd.volume': 'Khối lượng',
  'hr.kd.metrics': 'Chỉ số',
  'hr.kd.staff': 'Nhân sự',
  'hr.kd.avgDept': 'Điểm TB phòng',
  'hr.kd.confirmAdj': 'Xác nhận điều chỉnh',
  'hr.kd.activeMetrics': 'Chỉ số đang tính',
  'hr.kd.catalog': 'Danh mục · {k}',
  'hr.kd.rankTitle': 'Xếp hạng điểm · {p}',
  'hr.kd.rankSub': 'điểm cuối 0–100 · màu theo hạng',
  'hr.kd.gradeN': 'Hạng {g}',
  'hr.kd.byMetric': 'Điểm theo chỉ số · {p}',
  'hr.kd.heatNote': 'ô màu theo điểm',
  'hr.kd.person': 'Người',
  'hr.kd.seat': 'Ghế',
  'hr.kd.score': 'Điểm',
  'hr.kd.grade': 'Hạng',
  'hr.kd.noSet': 'chưa có bộ',
  'hr.kd.metricNames': 'Tên chỉ số',
  'hr.kd.wholePos': 'cả vị trí · Oct/2026',
  'hr.kd.volByPerson': '{m} theo người · {p}',
  'hr.kd.mainUnit': 'đơn vị sản lượng chính · Oct/2026',
  'hr.kd.volTitle': 'Khối lượng theo người · {p}',
  'hr.kd.countFrom': 'đếm từ dấu thao tác · ',
  'hr.kd.csPair': 'job xử lý theo cặp Sales/CS',
  'hr.kd.noWrite': 'Chưa mở ghi ở bản này',
  'hr.kd.loadHistory': 'Nạp lịch sử thao tác',
});
addMessages('en', {
  'hr.kr.noData': 'no data yet',
  'hr.kr.period': 'Period',
  'hr.kr.kindLabel': 'Definition type',
  'hr.kr.pending': 'awaiting sign-off',
  'hr.kr.metricKind': 'Metrics (Kind = Metric)',
  'hr.kr.metricSub': '36 rows · {n} with names mapped',
  'hr.kr.thCode': 'Code',
  'hr.kr.thName': 'Name',
  'hr.kr.thDept': 'Dept',
  'hr.kr.thUnit': 'Unit',
  'hr.kr.thDir': 'Direction',
  'hr.kr.thSource': 'Source',
  'hr.kr.thWeight': 'Weight · threshold',
  'hr.kr.penKind': 'Penalty catalog (Kind = Penalty)',
  'hr.kr.penSub': '9 rows · used in Error logging',
  'hr.kr.rewKind': 'Reward catalog (Kind = Reward)',
  'hr.kr.rewSub': '5 rows · 3 with names mapped',
  'hr.kr.rPraise': 'Written customer praise',
  'hr.kr.rRecover': 'Recovered incurred charges',
  'hr.kr.rSave': 'Cost savings',
  'hr.kr.rOther': '2 other rows',
  'hr.kr.rUnmapped': 'name not mapped',
  'hr.kr.sevKind': 'Severity (Kind = Severity)',
  'hr.kr.sevSub': '4 rows',
  'hr.kr.l1': 'Reminder, no charge incurred',
  'hr.kr.l2': 'Minor loss',
  'hr.kr.l3': 'Moderate loss',
  'hr.kr.l4': 'Severe / lost customer / legal',
  'hr.kr.sevPenalty': 'Deduction by severity, repeat factor',
  'hr.kr.unitKind': 'Points by volume',
  'hr.kr.paramKind': 'Parameters',
  'hr.kr.rows': '{n} rows',
  'hr.kr.unitNote': 'Reward points per volume unit (jobs, trips, completed services…).\nPoints per unit: awaiting sign-off.',
  'hr.kr.paramNote': 'Grade thresholds, manager adjustment range, minimum sample size, repeat factor…\nAll values: awaiting sign-off. Parameter changes take effect from the next period; closed periods are unchanged.',
  'hr.kr.metrics': 'Metrics',
  'hr.kr.defParam': 'definitions · parameters',
  'hr.kr.unitPts': 'Volume points',
  'hr.kr.penRewSev': 'Penalty / Reward / Severity',
  'hr.kr.rules': 'Reward rules',
  'hr.kr.rulesSub': 'by seat + grade',
  'hr.kr.seat': 'Seat',
  'hr.kr.grade': 'Grade',
  'hr.kr.field': 'Measured field',
  'hr.kr.how': 'Calculation',
  'hr.kr.effFrom': 'Effective from',
  'hr.kr.noRules': 'No rules yet.',
  'hr.noWrite': "Writing isn't enabled in this version",
  'hr.notYet': "This tab isn't available in this version",
  'hr.retry': 'Retry',
  'hr.backOverview': 'Back to Overview',
  'hr.kpi.title': 'KPI',
  'hr.kpi.live': 'Open',
  'hr.kpi.cycle': 'Cycle',
  'hr.kpi.month': 'Month',
  'hr.kpi.quarter': 'Quarter',
  'hr.kpi.period': 'Period',
  'hr.kpi.prev': 'Previous period',
  'hr.kpi.next': 'Next period',
  'hr.kpi.sampleOnly': 'Oct/2026 sample data only',
  'hr.kpi.density': 'Density',
  'hr.kpi.std': 'Standard',
  'hr.kpi.compact': 'Compact',
  'hr.kpi.notifTool': 'Notifications',
  'hr.kpi.notif': '4 new notifications · open in Tasks & Approvals',
  'hr.kpi.openRight': 'Open right panel',
  'hr.kpi.close': 'Close period',
  'hr.kpi.addRule': 'Add rule',
  'hr.kpi.closeOct': 'Close Oct/2026',
  'hr.kpi.exportMine': 'Export my card',
  'hr.kpi.export': 'Export KPI',
  'hr.kpi.emptyTitle': 'No KPI period yet',
  'hr.kpi.emptyDesc': 'No metric data for this period yet.',
  'hr.kpi.metrics': 'Metrics',
  'hr.kpi.scoredStaff': 'Staff scored',
  'hr.kpi.avgCo': 'Company avg score',
  'hr.kpi.avgNote': 'quality score 0–100',
  'hr.kpi.grade': 'Grade {g}',
  'hr.kpi.avgByDept': 'Average score by department',
  'hr.kpi.avgDept': 'Dept avg score',
  'hr.kpi.avgCoShort': 'Company avg',
  'hr.kpi.scale': 'scale 0–100',
  'hr.kpi.grading': 'Grading',
  'hr.kpi.gradingKpi': 'KPI grading',
  'hr.kpi.people': '{n} people',
  'hr.kpi.coRate': 'Company-level attainment',
  'hr.kpi.noTarget': 'company target not set',
  'hr.kpi.coMetrics': 'Company-level metrics',
  'hr.kpi.noTargetSrc': 'company target not set · real figures come from MINT/db',
  'hr.kpi.setTarget': 'Set company target',
  'hr.kpi.thMetric': 'Metric',
  'hr.kpi.thDept': 'Dept',
  'hr.kpi.thActual': 'Actual',
  'hr.kpi.thTarget': 'Target',
  'hr.kpi.thData': 'Data',
  'hr.kpi.thSource': 'Source',
  'hr.kc.short': 'Short',
  'hr.kc.enough': 'Complete',
  'hr.kc.timesheet': 'Monthly timesheet',
  'hr.kc.left': 'Open',
  'hr.kc.done': 'Done',
  'hr.kc.cases': '{n} cases',
  'hr.kc.pendingEv': 'Unapproved errors / commendations',
  'hr.kc.loaded': 'loaded',
  'hr.kc.actionMark': 'Action marker',
  'hr.kc.wait': 'Pending',
  'hr.kc.notSet': 'not set',
  'hr.kc.coTarget': 'Company target',
  'hr.kc.metrics': 'Metrics',
  'hr.kc.period': 'Period',
  'hr.kc.openRecalc': 'open · scores recalculate when data changes',
  'hr.kc.staffInPeriod': 'Staff in period',
  'hr.kc.scoredN': '{n} scored',
  'hr.kc.sheetsHave': 'Timesheets available',
  'hr.kc.openCases': 'Open error cases',
  'hr.kc.notEffNoCount': 'not counted until effective',
  'hr.kc.readiness': 'Close readiness',
  'hr.kc.readinessSub': 'timesheets and scores for Oct/2026',
  'hr.kc.staffScored': 'Staff scored',
  'hr.kc.noMetricSet': '{n} without a metric set',
  'hr.kc.before': 'Before closing',
  'hr.kc.noRecalc': 'no recalculation once closed',
  'hr.kc.who': 'Who can close',
  'hr.kc.bySeat': 'by seat',
  'hr.kc.closer': 'Closes the period',
  'hr.kc.proxy': 'HRD-MGR closes instead',
  'hr.kc.proxySub': 'if the BOD-DIR seat is empty, escalate by ReportTo',
  'hr.kc.proxyNo': 'No · only BOD-DIR closes',
  'hr.kc.writeTo': 'Writes to',
  'hr.kc.noData': 'no data yet',
  'hr.kc.periods': 'Periods',
  'hr.kc.noneClosed': 'no period closed yet',
  'hr.kc.status': 'Status',
  'hr.kc.closedBy': 'Closed by',
  'hr.kc.closedOn': 'Closed on',
  'hr.kc.headcount': 'Headcount',
  'hr.kc.live': 'Open',
  'hr.kc.notClosed': 'Not closed',
  'hr.ov.title': 'People & payroll',
  'hr.ov.updated': 'Updated at',
  'hr.ov.apprWait': 'Awaiting my approval',
  'hr.ov.tasks': 'Tasks',
  'hr.ov.more': 'More actions',
  'hr.ov.assignSeat': 'Assign seat',
  'hr.ov.newLeave': 'New leave request',
  'hr.ov.group': 'People groups',
  'hr.ov.emptyT': 'No leave requests this period',
  'hr.ov.emptyD': 'No leave requests, overtime slips or hiring requests for 10/2026 yet.',
  'hr.ov.tabClosed': 'This tab is not enabled in this version',
  'hr.ov.writeSuffix': "{msg} · writing isn't enabled in this version",
  'hr.ov.upcoming': 'Upcoming events',
  'hr.ov.upcomingHd': 'Upcoming events · 30 days',
  'hr.ov.toHandle': '{n} to handle',
  'hr.ov.handled': 'Handled',
  'hr.ov.moves': 'Headcount changes',
  'hr.ov.movesHd': 'Headcount changes · 2026',
  'hr.ov.lgWorking': 'Working',
  'hr.ov.lgIn': 'Joined',
  'hr.ov.lgOut': 'Left',
  'hr.ov.chartAria': 'Headcount at end of each month 2026: {list}. {vin} joined, {vout} left since the start of the year',
  'hr.ov.barTip': 'M{m}: {a} joined · {b} left',
  'hr.ov.note': '{vin} joined · {vout} left since the start of the year',
  'hr.ov.leave': 'Leave analysis',
  'hr.ov.leaveHd': 'Leave by month · 2026',
  'hr.ov.leaveSub': 'approved leave days',
  'hr.ov.leaveTip': 'Month {m}: {v} approved leave days',
  'hr.ov.topLeave': 'Most leave this year',
  'hr.ov.days': '{v} days',
  'hr.ov.mix': 'Workforce mix',
  'hr.ov.mixSub': '37 working',
  'hr.ov.mixTip': 'Aggregated figures, no individuals shown',
  'hr.ov.gender': 'Gender',
  'hr.ov.age': 'Age',
  'hr.ov.byDept': 'Stats by department',
  'hr.ov.thDept': 'Department',
  'hr.ov.thFill': 'Actual / planned',
  'hr.ov.thGap': 'Vacant',
  'hr.ov.thMgr': 'Managers',
  'hr.ov.thAge': 'Avg age',
  'hr.ov.thNote': 'Notes',
  'hr.ov.fillAria': '{name}: {act} of {plan} planned',
  'hr.tab.ov': 'Overview',
  'hr.tab.staff': 'People',
  'hr.tab.org': 'Structure & seats',
  'hr.tab.time': 'Attendance',
  'hr.tab.leave': 'Leave & handover',
  'hr.tab.ot': 'Overtime',
  'hr.tab.pay': 'Payroll',
  'hr.tab.kpi': 'KPI',
  'hr.tab.rec': 'Recruiting',
  'hr.kp.dept': 'Department',
  'hr.kp.all': 'All',
  'hr.kp.base': 'Base score',
  'hr.kp.baseSub': 'Average of metric scores',
  'hr.kp.pen': 'Active penalties',
  'hr.kp.penSub': 'points deducted · level pending approval',
  'hr.kp.rew': 'Active rewards',
  'hr.kp.rewSub': 'points added · level pending approval',
  'hr.kp.adj': 'Manager adjustment',
  'hr.kp.adjSub': 'no adjustment',
  'hr.kp.fin': 'Final score',
  'hr.kp.grade': 'Grade {g}',
  'hr.kp.mineLbl': 'My KPI {u}',
  'hr.kp.mineHd': 'My KPI · {u}',
  'hr.kp.confirm': 'confirmed by: {m}',
  'hr.kp.mgrAdj': 'Manager adjustment',
  'hr.kp.byMetric': 'Score by metric',
  'hr.kp.byMetricSub': 'score 0–100 · colour by grade',
  'hr.kp.metrics': 'Metrics',
  'hr.kp.noSet': 'this position has no metric set yet',
  'hr.kp.weights': 'weights and score thresholds: pending approval',
  'hr.kp.code': 'Code',
  'hr.kp.actual': 'Actual',
  'hr.kp.dir': 'Direction',
  'hr.kp.score': 'Score',
  'hr.kp.data': 'Data',
  'hr.kp.src': 'Source',
  'hr.kp.higher': 'higher is better',
  'hr.kp.lower': 'lower is better',
  'hr.kp.real': 'Actual',
  'hr.kp.sample': 'Sample',
  'hr.kp.noSeatSet': 'No metric set for seat {seat} yet · pending approval',
  'hr.kp.evHd': 'Penalties & rewards',
  'hr.kp.evSub': 'only Active cases count toward the score · ledger in BOD Report',
  'hr.kp.openLedgerNote': 'Open BOD Report › Penalties & rewards',
  'hr.kp.openLedger': 'Open ledger ›',
  'hr.kp.pen1': 'Penalty',
  'hr.kp.rew1': 'Reward',
  'hr.kp.noEv': 'No cases in this period',
  'hr.kp.staff': 'Staff',
  'hr.kp.staffSub': '{n} people · click to view card',
  'hr.kp.person': 'Person',
  'hr.kp.seat': 'Seat',
  'hr.kp.gradeCol': 'Grade',
  'hr.kd.pos': 'Position',
  'hr.kd.view': 'View',
  'hr.kd.quality': 'Quality',
  'hr.kd.volume': 'Volume',
  'hr.kd.metrics': 'Metrics',
  'hr.kd.staff': 'Staff',
  'hr.kd.avgDept': 'Dept avg score',
  'hr.kd.confirmAdj': 'Adjustment sign-off',
  'hr.kd.activeMetrics': 'Active metrics',
  'hr.kd.catalog': 'Catalog · {k}',
  'hr.kd.rankTitle': 'Score ranking · {p}',
  'hr.kd.rankSub': 'final score 0–100 · colored by grade',
  'hr.kd.gradeN': 'Grade {g}',
  'hr.kd.byMetric': 'Score by metric · {p}',
  'hr.kd.heatNote': 'cell color follows score',
  'hr.kd.person': 'Person',
  'hr.kd.seat': 'Seat',
  'hr.kd.score': 'Score',
  'hr.kd.grade': 'Grade',
  'hr.kd.noSet': 'no set yet',
  'hr.kd.metricNames': 'Metric names',
  'hr.kd.wholePos': 'whole position · Oct/2026',
  'hr.kd.volByPerson': '{m} by person · {p}',
  'hr.kd.mainUnit': 'main output unit · Oct/2026',
  'hr.kd.volTitle': 'Volume by person · {p}',
  'hr.kd.countFrom': 'counted from action stamps · ',
  'hr.kd.csPair': 'jobs handled per Sales/CS pair',
  'hr.kd.noWrite': 'Writing is not open in this version',
  'hr.kd.loadHistory': 'Load action history',
});
